import { render, staticRenderFns } from "./AddressComplete.vue?vue&type=template&id=56d1a61f&scoped=true"
import script from "./AddressComplete.vue?vue&type=script&lang=js"
export * from "./AddressComplete.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56d1a61f",
  null
  
)

export default component.exports